import useArenaxRealtime from './hooks/useArenaxRealtime';

/**
 * Phase 2J Realtime Phase 3 — Squad Online Indicator.
 *
 * Subscribes to the squad's presence channel and renders an ambient pulse
 * with the online count. Only members get a real signal; non-members see
 * nothing (auth-gated on the backend WS route).
 *
 * Tone: ambient sports-room energy, never a notification.
 */
export default function ArenaxSquadOnlineIndicator({ squadId, compact = false }) {
  const rt = useArenaxRealtime({ channel: 'squad', channelId: squadId, enabled: !!squadId });
  const count = rt?.presence?.online_count ?? 0;
  if (!count) return null;

  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-bold text-emerald-300"
        data-testid={`arenax-squad-online-compact-${squadId}`}>
        <span className="relative inline-block w-1.5 h-1.5">
          <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75" />
          <span className="absolute inset-0 rounded-full bg-emerald-400" />
        </span>
        {count} online
      </span>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/30"
      data-testid={`arenax-squad-online-${squadId}`}>
      <span className="relative inline-block w-2 h-2">
        <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75" />
        <span className="absolute inset-0 rounded-full bg-emerald-400" />
      </span>
      <span className="text-[10px] uppercase tracking-wider font-bold text-emerald-200">
        {count} {count === 1 ? 'squad-mate' : 'squad-mates'} online
      </span>
    </div>
  );
}
